import React from 'react';

export type FileInputLabelProps = {
    label: string
};


const FileInputLabel = (props: FileInputLabelProps) => <div
    style={{
        marginTop: "-52px"
    }}
>
    <span
        style={{
            fontSize: "11px",
            marginLeft: "15px",
            background: "#fff",
            color: "rgba(0, 0, 0, 0.54)",
            letterSpacing: "0.00938em",
        }}
    >
        {props.label}
    </span>
</div>


export default FileInputLabel;